<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre6" id="pgepubid00007">Full Page Illustrations</h2>
<p class="calibre2"><a href="#/Text/Section0009#norroway_illus">THE BLACK BULL OF NORROWAY</a></p>
<p class="calibre2"><span href="#/Text/Section0017#tattercoats_illus" title="Link target outside of Sample">TATTERCOATS</span></p>
<p class="calibre2"><span href="#/Text/Section0025#witch_illus" title="Link target outside of Sample">THE OLD WITCH</span></p>
<p class="calibre2"><span href="#/Text/Section0032#castle_illus" title="Link target outside of Sample">THE CASTLE OF MELVALES</span></p>
<p class="calibre2"><span href="#/Text/Section0040#bull_illus" title="Link target outside of Sample">THE LITTLE BULL-CALF</span></p>
<p class="calibre2"><span href="#/Text/Section0046#lambton_illus" title="Link target outside of Sample">THE LAMBTON WORM<br/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?2b4318a1